module.exports = __webpack_public_path__ + "static/sitefinity_logo-4324d96beece6ceb57931444ea8a3351.png";